export default {
  delay (state) {
    return state.delay
  }
}
